const middleware = {}

middleware['getLocaleNavigation'] = require('../middleware/getLocaleNavigation.js')
middleware['getLocaleNavigation'] = middleware['getLocaleNavigation'].default || middleware['getLocaleNavigation']

middleware['previewMode'] = require('../middleware/previewMode.js')
middleware['previewMode'] = middleware['previewMode'].default || middleware['previewMode']

export default middleware
